import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Calque 1",
  viewBox: "0 0 74.81 74.81"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M64.26 0H10.55C4.72 0 0 4.72 0 10.55v53.71c0 5.83 4.72 10.55 10.55 10.55h53.71c5.83 0 10.55-4.72 10.55-10.55V10.55C74.81 4.72 70.09 0 64.26 0m-.38 28.74H52.02v5.62h5.86v5.68h-5.86v8.4h11.86v5.68H46.07V40.04h-5.65v16.99L18.84 34.51v19.61h-5.95V19.94l21.58 22.57V23.06h5.95v11.3h5.65v-11.3h17.81z",
      style: {"fill":"currentColor"}
    }, null, -1)
  ]))]))
}
export default { render: render }